import React from "react";
import { Link as LinkR } from "react-router-dom";
import { DiCssdeck } from "react-icons/di";
import { FaBars } from "react-icons/fa";
import styled, { useTheme } from "styled-components";
import { Link as ScrollLink } from "react-scroll";

const handleGitHubButtonClick = () => {
	window.open("https://github.com/divyam878", "_blank");
};

const Nav = styled.div`
	background-color: ${({ theme }) => theme.card_light};
	height: 80px;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 1rem;
	position: sticky;
	top: 0;
	z-index: 10;
	@media (max-width: 960px) {
		trastion: 0.8s all ease;
	}
`;

const NavbarContainer = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	height: 60px;
	z-index: 1;
	width: 100%;
	padding: 0 24px;
	max-width: 1200px;
`;

const ButtonContainer = styled.div`
	width: 80%;
	height: 100%;
	display: flex;
	justify-content: end;
	align-items: center;
	padding: 0 6px;
	@media screen and (max-width: 768px) {
		display: none;
	}
`;

const GitHubButton = styled.button`
	background-color: transparent;
	border: 1.8px solid ${({ theme }) => theme.primary};
	justify-content: center;
	display: flex;
	align-items: center;
	height: 70%;
	border-radius: 20px;
	color: ${({ theme }) => theme.primary};
	cursor: pointer;
	padding: 0 20px;
	font-weight: 500;
	text-decoration: none;
	font-size: 16px;
	transition: all 0.6s ease-in-out;
	&:hover {
		background: ${({ theme }) => theme.primary};
		color: ${({ theme }) => theme.white};
	}
	@media screen and (max-width: 768px) {
		font-size: 14px;
	}
`;

const NavLogo = styled(LinkR)`
	width: 80%;
	padding: 0 6px;
	display: flex;
	justify-content: start;
	align-items: center;
	text-decoration: none;
	@media (max-width: 640px) {
		padding: 0 0px;
	}
`;

const NavItems = styled.ul`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 32px;
	padding: 0 6px;
	list-style: none;

	@media screen and (max-width: 768px) {
		display: none;
	}
`;

const Navlink = styled.a`
	color: ${({ theme }) => theme.text_primary};
	font-weight: 500;
	cursor: pointer;
	transition: all 0.2s ease-in-out;
	text-decoration: none;
	&:hover {
		color: ${({ theme }) => theme.primary};
	}

	&.active {
		border-bottom: 2px solid ${({ theme }) => theme.primary};
	}
`;

const MobileIcon = styled.div`
	display: none;
	@media screen and (max-width: 768px) {
		display: block;
		position: absolute;
		top: 0;
		right: 0;
		transform: translate(-100%, 60%);
		font-size: 1.5rem;
		cursor: pointer;
		color: ${({ theme }) => theme.text_primary};
	}
`;
const Span = styled.div`
	padding: 0 4px;
	font-weight: bold;
	font-size: 18px;
`;

const MobileMenuLink = styled(LinkR)`
	color: ${({ theme }) => theme.text_primary};
	font-weight: 500;
	cursor: pointer;
	transition: all 0.2s ease-in-out;
	text-decoration: none;
	&:hover {
		color: ${({ theme }) => theme.primary};
	}

	&.active {
		border-bottom: 2px solid ${({ theme }) => theme.primary};
	}
`;

const MobileMenu = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	gap: 16px;
	position: absolute;
	top: 80px;
	right: 0;
	width: 80%;
	padding: 12px 40px 24px 40px;
	background: ${({ theme }) => theme.card_light + 99};
	transition: all 0.6s ease-in-out;
	transform: ${({ open }) => (open ? "translateY(0)" : "translateY(-100%)")};
	border-radius: 0 0 20px 20px;
	box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
	opacity: ${({ open }) => (open ? "100%" : "0")};
	z-index: ${({ open }) => (open ? "1000" : "-1000")};
`;

function NavBar() {
	const [open, setOpen] = React.useState(false);
	const theme = useTheme();
	return (
		<Nav>
			<NavbarContainer>
				<NavLogo to="/">
					<a
						style={{
							display: "flex",
							alignItems: "center",
							color: "white",
							marginBottom: "20;",
							cursor: "pointer",
						}}
					>
						<DiCssdeck size="3rem" />
						<Span>Portfolio</Span>
					</a>
				</NavLogo>
				<MobileIcon>
					<FaBars
						onClick={() => {
							setOpen(!open);
						}}
					/>
				</MobileIcon>
				<NavItems>
					<ScrollLink
						to="about"
						spy={true}
						offset={-50}
						smooth={true}
						duration={500}
					>
						<Navlink>About</Navlink>
					</ScrollLink>
					<ScrollLink
						to="skills"
						spy={true}
						offset={-50}
						smooth={true}
						duration={500}
					>
						<Navlink>Skills</Navlink>
					</ScrollLink>
					<ScrollLink
						to="experience"
						spy={true}
						offset={-0}
						smooth={true}
						duration={500}
					>
						<Navlink>Experience</Navlink>
					</ScrollLink>

					<ScrollLink
						to="achievements"
						spy={true}
						offset={-0}
						smooth={true}
						duration={500}
					>
						<Navlink>Achievements</Navlink>
					</ScrollLink>
					<ScrollLink
						to="projects"
						spy={true}
						offset={-50}
						smooth={true}
						duration={500}
					>
						<Navlink>Projects</Navlink>
					</ScrollLink>
					<ScrollLink
						to="education"
						spy={true}
						offset={-50}
						smooth={true}
						duration={500}
					>
						<Navlink>Education</Navlink>
					</ScrollLink>
				</NavItems>
				<ButtonContainer>
					<GitHubButton
						style={{
							padding: "10px 16px",
							background: `${theme.primary}`,
							color: "white",
							width: "max-content",
						}}
						onClick={handleGitHubButtonClick}
					>
						Github Profile
					</GitHubButton>
				</ButtonContainer>
				{open && (
					<MobileMenu open={open}>
						<ScrollLink
							to="about"
							spy={true}
							offset={-50}
							smooth={true}
							duration={500}
						>
							<MobileMenuLink>About</MobileMenuLink>
						</ScrollLink>
						<ScrollLink
							to="skills"
							spy={true}
							offset={-80}
							smooth={true}
							duration={500}
						>
							<MobileMenuLink>Skills</MobileMenuLink>
						</ScrollLink>
						<ScrollLink
							to="experience"
							spy={true}
							offset={-50}
							smooth={true}
							duration={500}
						>
							<MobileMenuLink>Experience</MobileMenuLink>
						</ScrollLink>

						<ScrollLink
							to="achievements"
							spy={true}
							offset={-50}
							smooth={true}
							duration={500}
						>
							<MobileMenuLink>Achievements</MobileMenuLink>
						</ScrollLink>

						<ScrollLink
							to="projects"
							spy={true}
							offset={-50}
							smooth={true}
							duration={500}
						>
							<MobileMenuLink>Projects</MobileMenuLink>
						</ScrollLink>
						<ScrollLink
							to="education"
							spy={true}
							offset={-50}
							smooth={true}
							duration={500}
						>
							<MobileMenuLink>Education</MobileMenuLink>
						</ScrollLink>
						<GitHubButton
							style={{
								padding: "10px 16px",
								background: `${theme.primary}`,
								color: "white",
								width: "max-content",
							}}
							onClick={handleGitHubButtonClick}
						>
							Github Profile
						</GitHubButton>
					</MobileMenu>
				)}
			</NavbarContainer>
		</Nav>
	);
}

export default NavBar;
